import { axiosInstance } from "../axios/axios"

export const createSmallBusiness = async (formData: any) => {
    try {
        const payload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            job_title: formData.designation,
            work_email_address: formData.email,
            work_phone_no: formData.contact,
            organization_name: formData.orgName,
            organization_domain: formData.domain,
            organization_size: formData.size,
            region_id: formData.region,
            account_type: 'small-business'
        }
        const result = await axiosInstance.post('/create-small-business-customer', payload)
        console.log(result)
        return { customer: result.data?.data?.external_cust_ref, message: result.data.message, status: result.data.status }
    } catch (error: any) {
        console.log(error)
        return { errorMessage: error.response.data.message, status: error.response.data.status }
    }
}

export const createIndividual = async (formData: any) => {
    try {
        const payload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            work_email_address: formData.email,
            region_id: formData.region,
            account_type: 'individual'
        }
        const result = await axiosInstance.post('/create-individual-customer', payload)
        console.log(result)
        return { status: result.data.status, message: result.data.message, data: result.data.data }
    } catch (error: any) {
        console.log(error)
        return { status: error.response.data.status, message: error.response.data.message }
    }
}

export const createEnterprise = async (formData: any) => {
    try {
        const payload = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            job_title: formData.designation,
            work_email_address: formData.email,
            work_phone_no: formData.contact,
            organization_name: formData.orgName,
            organization_domain: formData.domain,
            organization_size: formData.size,
            region_id: formData.region,
            is_free_trial: formData.is_free_trial,
            no_of_licenses: Number(formData.license),
            account_type: 'enterprise'
        }
        const result = await axiosInstance.post('/create-enterprise-customer', payload)
        console.log(result)
        return { status: result.data.status, message: result.data.message, data: result.data.data }
    } catch (error: any) {
        console.log(error)
        return { status: error.response.data.status, message: error.response.data.message }
    }
}